import ankur from "./ankur.svg";
import asianPaints from "./asian-paints.webp";
import askModular from "./askmodular.png";
import durian from "./durian.svg";
import ergospace from "./ergospace.png";
import featherlite from "./featherlite.png";
import godrej from "./godrej.png";
import greenlam from "./greenlam.png";
import grohe from "./grohe.png";
import havells from "./havells.svg";
import haworth from "./haworth.png";
import hermanMiller from "./herman-miller.svg";
import jaquar from "./jaquar.svg";
import johnson from "./johnson.png";
import jrc from "./jrc.svg";
import kajaria from "./kajaria.svg";
import kalinga from "./kalinga.png";
import kohler from "./kohler.svg";
import merino from "./merino.jpg";
import monarch from "./monarch.png";
import nilkamal from "./nilkamal.jpg";
import nitco from "./nitco.png";
import orient from "./orient.png";
import orientbell from "./orientbell.png";
import pergo from "./pergo.png";
import philips from "./philips.png";
import rak from "./rak.png";
// import responsive from "./responsive.svg";
import simpolo from "./simpolo.png";
import somany from "./somany.jpg";
import steelcase from "./steelcase.svg";
import viak from "./viak.png";
import welspun from "./welspun.png";
import wipro from "./wipro.svg";
import toto from "./toto.png";
import armstrong from "./armstrong.png";
import responsiveIndustries from "./responsive.png";

export const logos = {
  ankur,
  asianPaints,
  askModular,
  durian,
  ergospace,
  featherlite,
  godrej,
  greenlam,
  grohe,
  havells,
  haworth,
  hermanMiller,
  jaquar,
  johnson,
  jrc,
  kajaria,
  kalinga,
  kohler,
  merino,
  monarch,
  nilkamal,
  nitco,
  orient,
  orientbell,
  pergo,
  philips,
  rak,
  //   responsive,
  simpolo,
  somany,
  steelcase,
  viak,
  welspun,
  wipro,
  toto,
  armstrong,
  responsiveIndustries,
};

export default logos;
